import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { Component, inject, OnDestroy } from '@angular/core';
import { filter } from 'rxjs/operators';
import { LayoutService } from '../../../shared/services/layout.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RoutePartsService } from '../../../shared/services/route-parts.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-breadcrumb',
	templateUrl: './breadcrumb.component.html',
	styleUrls: ['./breadcrumb.component.scss'],
	standalone: true,
	imports: [
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatTooltipModule,
    MatSidenavModule
]
})
export class BreadcrumbComponent implements OnDestroy {
	private router = inject(Router);
	private routePartsService = inject(RoutePartsService);
	private activeRoute = inject(ActivatedRoute);
	layout = inject(LayoutService);

	routeParts: any[];
	routerEventSub: Subscription;
	// public isEnabled: boolean = true;
	constructor() {
		this.routerEventSub = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(routeChange => {
			this.routeParts = this.routePartsService.generateRouteParts(this.activeRoute.snapshot);
			// generate url from parts
			this.routeParts.reverse().map((item, i) => {
				item.breadcrumb = this.parseText(item);
				item.urlSegments.forEach((urlSegment, j) => {
					if (j === 0) {
						return (item.url = `${urlSegment.path}`);
					}
					item.url += `/${urlSegment.path}`;
				});
				if (i === 0) {
					return item;
				}
				// prepend previous part to current part
				item.url = `${this.routeParts[i - 1].url}/${item.url}`;
				return item;
			});
		});
	}

	ngOnDestroy() {
		if (this.routerEventSub) {
			this.routerEventSub.unsubscribe();
		}
	}

	parseText(part) {
		part.breadcrumb = part.breadcrumb.replace(/{{([^{}]*)}}/g, function (a, b) {
			const r = part.params[b];
			return typeof r === 'string' ? r : a;
		});
		return part.breadcrumb;
	}
}
